import { useGlobalSearchParams } from 'expo-router'

export const useSearchProduct = (): string => {
    const { searchProduct } = useGlobalSearchParams<{ searchProduct?: string }>()

    return searchProduct ?? ''
}
